(function (global, factory) {
	typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports, require('apollo-link-core'), require('subscriptions-transport-ws'), require('promise-worker'), require('graphql')) :
	typeof define === 'function' && define.amd ? define(['exports', 'apollo-link-core', 'subscriptions-transport-ws', 'promise-worker', 'graphql'], factory) :
	(factory((global.webWorkerLink = {}),global.apolloLinkCore,global.subscriptionsTransportWs,global.PromiseWorker,global.graphql));
}(this, (function (exports,apolloLinkCore,subscriptionsTransportWs,PromiseWorker,graphql) { 'use strict';

PromiseWorker = PromiseWorker && PromiseWorker.hasOwnProperty('default') ? PromiseWorker['default'] : PromiseWorker;

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();









var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};











var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

var PromiseWorkerLink = function (_ApolloLink) {
  inherits(PromiseWorkerLink, _ApolloLink);

  function PromiseWorkerLink(_ref) {
    var worker = _ref.worker;
    classCallCheck(this, PromiseWorkerLink);

    var _this = possibleConstructorReturn(this, (PromiseWorkerLink.__proto__ || Object.getPrototypeOf(PromiseWorkerLink)).call(this));

    _this.promiseWorker = null;

    _this.promiseWorker = new PromiseWorker(worker);
    return _this;
  }

  createClass(PromiseWorkerLink, [{
    key: 'request',
    value: function request(operation) {
      var _this2 = this;

      return new apolloLinkCore.Observable(function (observer) {
        _this2.promiseWorker.postMessage(operation).then(function (data) {
          observer.next(data);
          observer.complete();
        }).catch(observer.error.bind(observer));
      });
    }
  }]);
  return PromiseWorkerLink;
}(apolloLinkCore.ApolloLink);

var createWorkerInterface = function createWorkerInterface(_ref2) {
  var worker = _ref2.worker;

  var WorkerInterface = function () {
    function WorkerInterface(url, protocol) {
      classCallCheck(this, WorkerInterface);

      this.url = url;
      this.protocol = protocol;
      this.readyState = WorkerInterface.OPEN; // webworker is always opened
    }

    createClass(WorkerInterface, [{
      key: 'close',
      value: function close() {
        console.log('closing noop');
      }
    }, {
      key: 'send',
      value: function send(serializedMessage) {
        console.log('sending', serializedMessage);
        worker.postMessage(serializedMessage);
      }
    }, {
      key: 'onopen',
      set: function set$$1(fn) {
        console.info('onopen noop');
      }
    }, {
      key: 'onclose',
      set: function set$$1(fn) {
        console.log('onclose noop');
      }
    }, {
      key: 'onerror',
      set: function set$$1(fn) {
        worker.onerror = fn;
      }
    }, {
      key: 'onmessage',
      set: function set$$1(fn) {
        worker.onmessage = function (_ref3) {
          var data = _ref3.data;

          var d = JSON.parse(data);
          if (d.type === 'data') {
            fn({ data: data });
          }
        };
      }
    }]);
    return WorkerInterface;
  }();

  WorkerInterface.CLOSED = 'CLOSED';
  WorkerInterface.OPEN = 'OPEN';
  WorkerInterface.CONNECTING = 'CONNECTING';

  return WorkerInterface;
};

var SubscriptionWorkerLink = function (_ApolloLink2) {
  inherits(SubscriptionWorkerLink, _ApolloLink2);

  function SubscriptionWorkerLink(_ref4) {
    var worker = _ref4.worker;
    classCallCheck(this, SubscriptionWorkerLink);

    var _this3 = possibleConstructorReturn(this, (SubscriptionWorkerLink.__proto__ || Object.getPrototypeOf(SubscriptionWorkerLink)).call(this));

    _this3.worker = null;
    _this3.subscriptionClient = null;

    _this3.worker = worker;
    _this3.subscriptionClient = new subscriptionsTransportWs.SubscriptionClient(null, {}, createWorkerInterface({ worker: worker }));
    return _this3;
  }

  createClass(SubscriptionWorkerLink, [{
    key: 'request',
    value: function request(operation) {
      return this.subscriptionClient.request(operation);
    }
  }]);
  return SubscriptionWorkerLink;
}(apolloLinkCore.ApolloLink);

// TODO: quick hack
var isSubscription = function isSubscription(operation) {
  return operation.query.definitions[0].operation === 'subscription';
};

var createWebWorkerLink = function createWebWorkerLink(_ref5) {
  var worker = _ref5.worker;
  return apolloLinkCore.ApolloLink.split(isSubscription, new SubscriptionWorkerLink({ worker: worker }), new PromiseWorkerLink({ worker: worker }));
};

var registerPromiseWorker = require('promise-worker/register');

var createWorker = function createWorker(_ref) {
  var schema = _ref.schema,
      context = _ref.context,
      _ref$beforeRequest = _ref.beforeRequest,
      beforeRequest = _ref$beforeRequest === undefined ? function () {
    return Promise.resolve();
  } : _ref$beforeRequest;
  return registerPromiseWorker(function (request) {
    if (request) {
      return beforeRequest(request).then(function () {
        return graphql.execute(schema, request.query, {}, Object.assign({}, request.context || {}, context), request.variables, request.operationName);
      });
    }
    return Promise.resolve();
  });
};

var handleSubscriptions = function handleSubscriptions(_ref2) {
  var self = _ref2.self,
      message = _ref2.message,
      schema = _ref2.schema,
      pubsub = _ref2.pubsub,
      context = _ref2.context;

  var messageData = JSON.parse(message.data);
  if (messageData.type === 'start') {
    var payload = messageData.payload;
    pubsub.subscribe(payload.operationName, function (data) {
      return graphql.execute(schema, graphql.parse(payload.query), data, context, payload.variables || {}, payload.operationName).then(function (_ref3) {
        var data = _ref3.data,
            errors = _ref3.errors;

        if (errors) console.error(errors[0]);
        self.postMessage(JSON.stringify({
          type: 'data',
          id: messageData.id,
          payload: {
            errors: errors,
            data: data
          }
        }));
      });
    });
  }
};

exports.PromiseWorkerLink = PromiseWorkerLink;
exports.createWorkerInterface = createWorkerInterface;
exports.SubscriptionWorkerLink = SubscriptionWorkerLink;
exports.isSubscription = isSubscription;
exports.createWebWorkerLink = createWebWorkerLink;
exports.createWorker = createWorker;
exports.handleSubscriptions = handleSubscriptions;

Object.defineProperty(exports, '__esModule', { value: true });

})));
//# sourceMappingURL=bundle.umd.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/apollo-link-webworker/dist/bundle.umd.js
// module id = 575
// module chunks = 0